import axiosInstance from '../auth/axiosInstance';

export const changePassword = async (userData) => {
  try {
    const { oldPassword, password } = userData;

    const { data } = await axiosInstance.post(
      `/User/change-password/${userData.userId}`,
      { oldPassword, password }
    );

    return data;
  } catch (error) {
    const errorMessage = error.response
      ? error.response.data.message || error.message
      : error.message;
    throw new Error(errorMessage);
  }
};
